module.exports = __webpack_public_path__ + "img/statement.3e951ba2.svg";